module.exports = __webpack_public_path__ + "img/vertical_6_3_0.87057866.png";